import classNames from 'classnames';
import React from 'react';
import { ITranslateProps, translate } from '../../mixins/translate';

export interface IMessageProps extends ITranslateProps {
    small?: boolean | undefined;
    message?: React.ReactNode | undefined;
}

class DisplayMessageComponent extends React.Component<IMessageProps, Record<string, unknown>> {
    private classValue = classNames({
        alert: true,
        'alert-sm': true,
        'alert-border-left': true,
        'alert-danger': true,
        'alert-dismissable': true,
        mw1000: !this.props.small,
        mw700: this.props.small,
    });

    public override render() {
        if (!this.props.message) {
            return null;
        }

        let message: React.ReactNode = this.props.message || 'Some went wrong. Please try again.';
        if (typeof message === 'string') {
            message = <strong>{message}</strong>;
        }

        return (
            <div>
                <div className={this.classValue} style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}>
                    <button type="button" className="close" data-dismiss="alert" aria-hidden="true">
                        ×
                    </button>
                    <i className="fa fa-warning pr10"></i> <strong>{message}</strong>
                </div>
            </div>
        );
    }
}
// eslint-disable-next-line @typescript-eslint/naming-convention
const DisplayMessage = translate()(DisplayMessageComponent);
export { DisplayMessage };
